import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";

const fragments = {
	LINK: '[data-fragment="CanteenEmployeeToggle.link"]',
};

class CanteenEmployeeToggle extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		const jsonMessagesComponentElement = document.getElementById('jsonMessages');
		this.jsonMessagesComponent = getWebComponentInstance(jsonMessagesComponentElement);


		this.emailElement = this.element.querySelectorAll('[name="frm.email"]');

		this.on('click', fragments.LINK, this.handleClickOnLink);

		this.initEmailElement();

		this.initElements();
	}

	handleClickOnLink = (e) => {
		e.preventDefault();
		this.commitChanges(e);
	}

	initEmailElement = () => {
		for(let i = 0; i < this.emailElement.length; i++){
			this.emailElement[i].addEventListener('change', (e) => {
				let mailFormat = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
				let link = e.target.parentElement.parentElement.querySelector('[data-fragment="CanteenEmployeeToggle.link"]');
				if(e.target.value.match(mailFormat)){
					link.classList.remove('hidden');
				} else {
					link.classList.add('hidden');
				}
			});
		}
	}

	initElements = () => {
		this.rowsElement = this.element.querySelectorAll('tbody > tr');
		for(let i = 0;i < this.rowsElement.length; i++) {
			let isEmailEmpty = false;
			let frmEmail = this.rowsElement[i].querySelector('[name="frm.email"]');
			if(frmEmail && frmEmail.value === ''){
				isEmailEmpty = true;
			}
			if(isEmailEmpty) {
				let link = this.rowsElement[i].querySelector('[data-fragment="CanteenEmployeeToggle.link"]');
				link.classList.add('hidden');
			}
		}
	}

	commitChanges = (e) => {
		this.universalPreloaderComponent.handleOn(10);
		let dataJSON = [];
		let commitUrl = window.location.pathname + '?csrf=' + this.getCsrfToken() + this.getFormId() + '&eventName.storeEmployeeCanteenOptions';
		let xmlHttpReq = new XMLHttpRequest();
		let _self = this;

		let rowElement = e.target.parentElement.parentElement;
		let stateValue = false;
		if(e.target.getAttribute('data-state') === 'false') {
			stateValue = true;
		}

		let emailValue = '';
		let employeeIdValue = e.target.getAttribute('data-employee-id');

		let emailElement = rowElement.querySelector('[name="frm.email"]');
		if(emailElement && emailElement.value !== '') {
			emailValue = emailElement.value;
		} else {
			emailValue = e.target.getAttribute('data-email');
		}

		dataJSON = {
			email: emailValue,
			active: stateValue,
			employeeId: parseInt(employeeIdValue),
		};
		xmlHttpReq.open('POST', commitUrl, true);
		xmlHttpReq.setRequestHeader("Content-Type", "application/json");
		xmlHttpReq.onreadystatechange = function () {
			if (xmlHttpReq.readyState === 4) {
				if (xmlHttpReq.status === 200) {
					let data = JSON.parse(xmlHttpReq.responseText);
					if (data.ok) {
						e.target.setAttribute('data-state', stateValue);
						if(stateValue){
							e.target.children[0].classList.add('svg-icon--success');
							e.target.children[0].classList.remove('svg-icon--secondary');
						} else {
							e.target.children[0].classList.remove('svg-icon--success');
							e.target.children[0].classList.add('svg-icon--secondary');
						}
					} else {
						_self.jsonMessagesComponent.showAlert('danger', 'Chyba aplikácie');
					}
				}
			}
			_self.universalPreloaderComponent.handleOff(10);
		};
		xmlHttpReq.send(JSON.stringify(dataJSON));
	}

	getCsrfToken = () => {
		return document.querySelector('form input[name=csrf]').value;
	};

	getFormId = () => {
		let formId = document.querySelector('form input[name=formId]');
		if(formId) {
			return '&formId=' + formId.value;
		}
		return '';
	};
}

export default CanteenEmployeeToggle;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Canteen/CanteenEmployeeToggle.js